import { useState, useCallback } from 'react';

/**
 * Hook para cache inteligente de dados
 * Evita chamadas desnecessárias ao banco quando os dados já estão "frescos"
 */
export const useDataCache = (cacheDuration = 30 * 1000) => { // 30 segundos por padrão
  const [cache, setCache] = useState({ data: null, timestamp: 0 });

  const getCachedData = useCallback((key) => {
    const now = Date.now();
    const cached = cache[key];
    
    if (cached && (now - cached.timestamp) < cacheDuration) {
      return cached.data;
    }
    
    return null;
  }, [cache, cacheDuration]);

  const setCachedData = useCallback((key, data) => {
    setCache(prev => ({
      ...prev,
      [key]: {
        data,
        timestamp: Date.now()
      }
    }));
  }, []);

  const clearCache = useCallback((key) => {
    if (key) {
      setCache(prev => {
        const newCache = { ...prev };
        delete newCache[key];
        return newCache;
      });
    } else {
      setCache({});
    }
  }, []);

  const isCacheValid = useCallback((key) => {
    const now = Date.now();
    const cached = cache[key];
    return cached && (now - cached.timestamp) < cacheDuration;
  }, [cache, cacheDuration]);

  return {
    getCachedData,
    setCachedData,
    clearCache,
    isCacheValid
  };
};